import { render } from "./HeroiconsSolidPhoneIncoming.vue?vue&type=template&id=84c6c904"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPhoneIncoming.vue"]])

export default __exports__